export const AllPotentialMapping = [
    { value: "defaultPotential", label: "Baixo volume de Projetos" },
    { value: "highPotencial", label: "Alto volume de Projetos" }
    
];